import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import {
  FormLabel,
  ModalError,
  NumberInput,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import { useEffect, useState } from "react";
import { validateEmail } from "utils";

const ModalFormOriginalPublisher = ({
  open,
  onClose,
  preload,
  handleSubmit,
  loadingButton,
}) => {
  const [payload, setPayload] = useState({
    name: "",
    phone: "",
    email: "",
    ipi_name_number: "",
    ipi_base_number: "",
    transmitter_code: "",
  });
  const [emailError, setEmailError] = useState(null);

  const handleChangePayload = (value, key) => {
    if (key === "ipi_name_number") {
      if (/\D/.test(value)) {
        return;
      }

      if (value.length > 11) {
        return;
      }
    }

    if (key === "ipi_base_number") {
      if (value.length > 11) {
        return;
      }
    }

    if (key === "email") {
      setEmailError(null);
    }
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const getPreload = () => {
    setPayload({
      original_publisher_id: preload?.original_publisher_id,
      name: preload?.name,
      phone: preload?.phone,
      email: preload?.email,
      ipi_base_number: preload?.ipi_base_number,
      ipi_name_number: preload?.ipi_name_number,
      transmitter_code: preload?.transmitter_code,
    });
  };

  const onSubmit = () => {
    let hasError = false;

    const { email, ipi_name_number, ipi_base_number } = payload;
    if (!validateEmail(email)) {
      ModalError(
        "Invalid email, please enter your email address in format: yourname@example.com"
      );
      hasError = true;
    }

    if (hasError) return;
    handleSubmit(payload);
  };

  useEffect(() => {
    getPreload();
  }, [preload]);

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>{`${
        preload ? "Edit" : "Add"
      } Original Publisher`}</DialogTitle>
      <DialogContent>
        <Grid container direction="column" rowSpacing={1}>
          <Grid item>
            <FormLabel label="Original Publisher Name" required />
            <TextInput
              placeholder="Original Publisher Name"
              value={payload?.name}
              onChange={e => handleChangePayload(e?.target?.value, "name")}
              disabled={loadingButton}
            />
          </Grid>
          <Grid item>
            <FormLabel label="Phone Number" required />
            <TextInput
              placeholder="Phone Number"
              value={payload?.phone}
              onChange={e => handleChangePayload(e?.target?.value, "phone")}
              disabled={loadingButton}
            />
          </Grid>
          <Grid item>
            <FormLabel label="Email" required />
            <TextInput
              placeholder="Email"
              value={payload?.email}
              onChange={e => handleChangePayload(e?.target?.value, "email")}
              error={!!emailError}
              helperText={emailError}
              disabled={loadingButton}
            />
          </Grid>
          <Grid item>
            <FormLabel label="IPI Name Number" required />
            <NumberInput
              placeholder="IPI Name Number"
              autoComplete={`ipi_name_number`}
              value={payload?.ipi_name_number}
              onChange={e => handleChangePayload(e, "ipi_name_number")}
              disabled={loadingButton}
            />
          </Grid>
          <Grid item>
            <FormLabel label="IPI Base Number" />
            <TextInput
              placeholder="IPI Base Number"
              value={payload?.ipi_base_number}
              onChange={e =>
                handleChangePayload(e?.target?.value, "ipi_base_number")
              }
              disabled={loadingButton}
            />
          </Grid>
          <Grid item>
            <FormLabel label="Transmitter Code" />
            <TextInput
              placeholder="Transmitter Code"
              value={payload?.transmitter_code}
              onChange={e =>
                handleChangePayload(e?.target?.value, "transmitter_code")
              }
              disabled={loadingButton}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <SecondaryButton label="Cancel" onClick={onClose} />
        <PrimaryButton
          label={
            loadingButton
              ? preload
                ? "Updating"
                : "Saving"
              : preload
              ? "Update"
              : "Save"
          }
          loading={loadingButton}
          disabled={loadingButton}
          onClick={onSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalFormOriginalPublisher;
